import Modal from "@mui/material/Modal";
import {kModalStyles} from "../../../constants/styles";
import SystemScreenInfoHeader from "../../headers/SystemScreenInfoHeader";
import {kSystemIcons} from "../../../constants/icons";

export default function LevelAKnowledgeExplanationDialog({open, handleClose}) {
    // Used in LevelAMetaData to display modal with
    // example zoomed picture

    // BUILD
    return(
        <Modal open={open}
               onClose={handleClose}>
            <div className={kModalStyles.screenInfoDialogStyle}>
                <SystemScreenInfoHeader handleClose={handleClose}
                                        icon={kSystemIcons.heart}
                                        title={"La connaissance"} />
                {/** CONTENT */}
                <div className={"w-full flex flex-col justify-start items-start p-[24px]"}>
                     <span className={"font-bold text-[18px] text-white -mt-[6px]"}>
                       {"Chaque savoir-faire repose sur un connaissance, c'est ce que tu dois comprendre et apprendre par coeur."}
                    </span>
                    <span className={"font-normal text-[14px] text-greyLight9 mt-[12px]"}>
                        {"Il y a 5 types de connaissance\u00A0:"}
                    </span>
                    <ul className={"list-disc pl-[16px] mt-[8px] font-normal text-[14px] text-greyLight9 space-y-[4px]"}>
                        <li>
                            <span>
                                {"Définition\u00A0: Phrase qui explique ce que veut dire un mot ou une idée."}
                            </span>
                        </li>
                        <li>
                            <span>
                                {"Méthode\u00A0: Façon de faire, avec des étapes, pour réussir un exercice."}
                            </span>
                        </li>
                        <li>
                            <span>
                                {"Formule\u00A0: Règle choisie pour que tout le monde écrive ou comprenne les maths de la même façon."}
                            </span>
                        </li>
                        <li>
                            <span>
                                {"Convention\u00A0: Écriture mathématique qui permet de calculer plus vite."}
                            </span>
                        </li>
                        <li>
                            <span>
                                {"Propriété & Théorème\u00A0: C’est une règle vraie en maths, utilisée pour raisonner ou calculer."}
                            </span>
                        </li>
                    </ul>
                </div>
            </div>
        </Modal>
    )
}